exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background:#fff}.Main__container{padding:13.3rem 0 7rem;background:#ffffe1}.Main__container--minHeight{min-height:60vh}a,a:hover{color:inherit;text-decoration:underline}.Error__text{margin:35px 0}.AppButtons{text-align:right}.FloatingDownloadButtons{position:fixed;left:auto;top:auto;right:20px;bottom:20px;z-index:10}.FloatingDownloadButtons a:first-child{padding-right:15px}.FloatingDownloadButtons img{height:40px}.bold{font-weight:bold}", ""]);

// exports
